import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../ts/Glob';
import * as reactGlobalClick from '../../../_common/platform/ts/reactGlobalClick';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';
import { IValuesCollection } from '../../../_common/platform/ts/appTheme';

import {
    SuggestionSelect,
    ISuggestionValue,
    convertFromHashToDisplayValues
} from '../../../_common/platform/tsx/SuggestionSelect';

//'types' are an array to control the order of appearance.
const USER_OR_GROUP_SUGGESTION_SELECT_TYPES = [
    {
        key: 'group',
        title: 'Group'
    },
    {
        key: 'user',
        title: 'User'
    }
];

const USERS_OR_GROUPS_LIST_THRESHOLD = 50;

function getPermissionsArr(number, permissions) {
    const arr = _.filter(permissions, function (obj: any) {
        return (number & obj.id) === obj.id;
    });

    return _.map(arr, function (obj: any) {
        return obj.description;
    });
}

class PermissionsEdit extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            editMode: false
        };
    }

    setEditMode = () => {
        this.setState({
            editMode: true
        });
    };

    unsetEditMode = () => {
        this.setState({
            editMode: false
        });
    };

    getAllowClickHandler = (id) => {
        let _self = this;

        return function () {
            let checked = (_self.props.permissionsadded & id) === id;

            let permissionsdenied = _self.props.permissionsdenied;

            if (checked === false) {
                permissionsdenied = ~id & permissionsdenied;
            }

            _self.handleChange(_self.props.permissionsadded ^ id, permissionsdenied);
        };
    };

    getDenyClickHandler = (id) => {
        let _self = this;

        return function () {
            let checked = (_self.props.permissionsdenied & id) === id;

            let permissionsadded = _self.props.permissionsadded;

            if (checked === false) {
                permissionsadded = ~id & permissionsadded;
            }

            _self.handleChange(permissionsadded, _self.props.permissionsdenied ^ id);
        };
    };

    handleChange = (permissionsadded, permissionsdenied) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(permissionsadded, permissionsdenied);
        }
    };

    getEdit = () => {
        let _self = this;

        let rows = _.map(this.props.permissions, function (obj: any, i) {
            return (
                <tr key={'tr-' + i}>
                    <td>{obj.description}</td>

                    <td className="cell-allow">
                        <div
                            className={
                                'btn btn-xs btn-success' +
                                ((_self.props.permissionsadded & obj.id) === obj.id ? ' active' : '')
                            }
                            onClick={_self.getAllowClickHandler(obj.id)}
                        >
                            <span className="glyphicon glyphicon-ok"></span>
                            <span>Allow</span>
                        </div>
                    </td>

                    <td className="cell-deny">
                        <div
                            className={
                                'btn btn-xs btn-danger' +
                                ((_self.props.permissionsdenied & obj.id) === obj.id ? ' active' : '')
                            }
                            onClick={_self.getDenyClickHandler(obj.id)}
                        >
                            <span className="glyphicon glyphicon-ok"></span>
                            <span>{'Deny'}</span>
                        </div>
                    </td>
                </tr>
            );
        });

        return (
            <table className="table edit-table">
                <tbody>{rows}</tbody>
            </table>
        );
    };

    getView = () => {
        let added = getPermissionsArr(this.props.permissionsadded, this.props.permissions);

        let denied = getPermissionsArr(this.props.permissionsdenied, this.props.permissions);

        let addedDisplay;
        let deniedDisplay;

        if (added.length === 0) {
            addedDisplay = (
                <em className="permissions-display" key="added-display">
                    {'none'}
                </em>
            );
        } else {
            addedDisplay = (
                <span className="permissions-display" key="added-display">
                    {added.join(', ')}
                </span>
            );
        }

        if (denied.length === 0) {
            deniedDisplay = (
                <em className="permissions-display" key="denied-display">
                    {'none'}
                </em>
            );
        } else {
            deniedDisplay = (
                <span className="permissions-display" key="denied-display">
                    {denied.join(', ')}
                </span>
            );
        }

        return [<strong key="s-1">Added: </strong>, addedDisplay, <strong key="s-2">Denied: </strong>, deniedDisplay];
    };

    render() {
        let content;
        let button;

        if (this.state.editMode === true) {
            content = this.getEdit();

            button = (
                <div className="btn btn-xs btn-success" onClick={this.unsetEditMode}>
                    <span className="glyphicon glyphicon-ok"></span>
                    <span>{'OK'}</span>
                </div>
            );
        } else {
            content = this.getView();

            button = (
                <div className="btn btn-xs btn-info" onClick={this.setEditMode}>
                    <span className="glyphicon glyphicon-pencil"></span>
                    <span>{'Edit'}</span>
                </div>
            );
        }

        return (
            <div className="permissions-edit">
                {button}
                {content}
            </div>
        );
    }
}

class SpecificPermissionsRow extends React.Component<
    {
        value;
        i?;
        permissions;
        usersOrGroups;
        theme: IValuesCollection;
        glob: IGlob;

        onChange(value, i): void;
        onRemove?(i): void;
    },
    any
> {
    handleUserOrGroupChange = (value: ISuggestionValue[]) => {
        const obj = _.clone(this.props.value || {});

        if (value != null && value.length > 0) {
            obj.userid = parseInt(value[0].value);
        } else {
            obj.userid = null;
        }

        this.handleValueChange(obj);
    };

    handlePermissionsChange = (permissionsadded, permissionsdenied) => {
        let obj = _.clone(this.props.value || {});

        obj.permissionsadded = permissionsadded;
        obj.permissionsdenied = permissionsdenied;

        this.handleValueChange(obj);
    };

    handleValueChange = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton = (value) => {
        if (value.userid == null) {
            return;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    };

    getPermissions = (value) => {
        if (value.permissionsadded == null || value.permissionsdenied == null) {
            return;
        }

        return (
            <PermissionsEdit
                permissionsadded={value.permissionsadded}
                permissionsdenied={value.permissionsdenied}
                permissions={this.props.permissions}
                glob={this.props.glob}
                onChange={this.handlePermissionsChange}
            />
        );
    };

    render() {
        let value = this.props.value || {};
        let userOrGroupValue = [];

        if (this.props.value.userid) {
            userOrGroupValue.push(this.props.value.userid);
        }

        const displayValues = convertFromHashToDisplayValues(this.props.usersOrGroups);

        return (
            <tr>
                <td className="remove">{this.getRemoveButton(value)}</td>

                <td className="user-group">
                    <SuggestionSelect
                        value={userOrGroupValue}
                        displayValues={displayValues}
                        singleSelectMode={true}
                        allowNull={false}
                        //search={ this.userOrGroupSearch }
                        keySelect={true}
                        sortByDisplayValue={true}
                        types={USER_OR_GROUP_SUGGESTION_SELECT_TYPES}
                        listThreshold={USERS_OR_GROUPS_LIST_THRESHOLD}
                        theme={this.props.theme}
                        glob={this.props.glob}
                        onChange={this.handleUserOrGroupChange}
                    />
                </td>

                <td className="permissions">{this.getPermissions(value)}</td>
            </tr>
        );
    }
}

class SpecificPermissions extends React.Component<
    {
        value;
        dirid;
        usersOrGroups;
        permissions;
        theme: IValuesCollection;
        glob: IGlob;

        onChange(value): void;
    },
    any
> {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value
        };
    }

    componentDidMount() {
        this.handleValueChange(this.state.value);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.dirid !== nextProps.dirid) {
            this.setState({
                value: nextProps.value
            });

            this.handleValueChange(nextProps.value);
        }
    }

    handleValueChange = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    addRow = (obj) => {
        let value = this.state.value.slice(0);

        obj.permissionsadded = 0;
        obj.permissionsdenied = 0;

        value.push(obj);

        this.handleValueChange(value);
        this.setState({
            value: value
        });
    };

    changeRow = (obj, i) => {
        let value = this.state.value.slice(0);

        value.splice(i, 1, obj);

        this.handleValueChange(value);
        this.setState({
            value: value
        });
    };

    removeRow = (i) => {
        let value = this.state.value.slice(0);

        value.splice(i, 1);

        this.handleValueChange(value);
        this.setState({
            value: value
        });
    };

    render() {
        const rows = _.map(this.state.value, (permission, i) => {
            return (
                <SpecificPermissionsRow
                    value={permission}
                    theme={this.props.theme}
                    glob={this.props.glob}
                    key={'spRow_' + i}
                    i={i}
                    usersOrGroups={this.props.usersOrGroups}
                    permissions={this.props.permissions}
                    onChange={this.changeRow}
                    onRemove={this.removeRow}
                />
            );
        });

        let empty;

        if (rows.length === 0) {
            empty = (
                <tr>
                    <td colSpan={3}>
                        <em>{'List of permissions is empty'}</em>
                    </td>
                </tr>
            );
        }

        return (
            <table className="table table-bordered permissions-dir-table" key="specific-permissions">
                <thead>
                    <tr>
                        <th className="remove"></th>
                        <th className="user-group">{'User or Group'}</th>
                        <th className="permissions">{'Permissions'}</th>
                    </tr>
                </thead>

                <tbody>
                    {rows}
                    {empty}
                    <SpecificPermissionsRow
                        value={{}}
                        key="spRow_last"
                        usersOrGroups={this.props.usersOrGroups}
                        permissions={this.props.permissions}
                        theme={this.props.theme}
                        glob={this.props.glob}
                        onChange={this.addRow}
                    />
                </tbody>
            </table>
        );
    }
}

export class DirPermissions extends React.Component<
    {
        theme: IValuesCollection;
        glob: IGlob;
    },
    any
> {
    //LL: 31.01.25 
    private references: {
        container?: HTMLElement; // HTMLDivElement;
        header?: HTMLElement; // HTMLDivElement;
        footer?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = _.extend(
            {},
            this.getState(),
            {
                permissionsSpecific: [],
                containerSize: 0
            }
        );
    }

    getState() {
        return this.props.glob.PermissionsStore.getState();
    }

    hanldeOnStoreChange = () => {
        this.setState(this.getState());
    };

    componentDidMount() {
        this.setContainerSize();

        $(window).on('resize', this.setContainerSize);

        this.props.glob.PermissionsStore.addChangeListener(this.hanldeOnStoreChange);
    }

    componentWillUnmount() {
        $(window).off('resize', this.setContainerSize);

        this.props.glob.PermissionsStore.removeChangeListener(this.hanldeOnStoreChange);
    }

    handleSpecificPermissionsChange = (value) => {
        this.setState({
            permissionsSpecific: value
        });
    };

    setContainerSize = () => {
        if (this.state.resized === true) {
            return;
        }

        let container = this.references.container;
        let header = this.references.header;
        let footer = this.references.footer;

        this.setState({
            containerSize: $(container).height() - $(header).outerHeight() - $(footer).outerHeight()
        });
    };

    handleOnCloseDialog = (e) => {
        this.props.glob.AppActions.permissionsDirHide();
    };

    handleOnSavePermissions = (e) => {
        this.props.glob.AppActions.permissionsDirSave(
            this.state.displayDir,
            this.state.displayName,
            this.state.permissionsSpecific
        );

        e.stopPropagation();
        e.preventDefault();
    };

    getActionButtons = () => {
        if (
            this.state.dirLoading === true ||
            this.state.initialLoading === true ||
            this.state.invalidPermission === true
        ) {
            return [];
        }

        return [
            <div key="dir-perm-action-buttons" className="btn btn-success" onClick={this.handleOnSavePermissions}>
                {'Save'}
            </div>
        ];
    };

    getInherited = (obj) => {
        const rows = _.map(obj.inherited, (permission: any, i) => {
            let userOrGroup = this.state.usersOrGroups[permission.userid];

            let name = userOrGroup && userOrGroup.name;

            return (
                <tr key={'tr-' + i}>
                    <td className="user-group">{name}</td>

                    <td className="permissions">
                        {getPermissionsArr(permission.permissions, this.state.permissions).join(', ')}
                    </td>
                </tr>
            );
        });

        let empty;

        if (rows.length === 0) {
            empty = (
                <tr>
                    <td colSpan={3}>
                        <em>{'List of permissions is empty'}</em>
                    </td>
                </tr>
            );
        }

        return (
            <table key="inherited-permissions" className="table table-bordered permissions-dir-table">
                <thead>
                    <tr>
                        <th className="user-group">{'User or Group'}</th>

                        <th className="permissions">{'Permissions'}</th>
                    </tr>
                </thead>

                <tbody>
                    {rows}
                    {empty}
                </tbody>
            </table>
        );
    };

    getSpecific = (obj) => {
        return (
            <SpecificPermissions
                key="specific-permissions"
                glob={this.props.glob}
                dirid={this.state.displayDir}
                value={obj.specific}
                usersOrGroups={this.state.usersOrGroups}
                permissions={this.state.permissions}
                theme={this.props.theme}
                onChange={this.handleSpecificPermissionsChange}
            />
        );
    };

    getView = () => {
        const permissions = this.state.dirPermissions[this.state.displayDir];

        if (permissions == null) {
            if (this.state.invalidPermission === true) {
                //ryb: in a case when User has no permission
                return <em>{'You have no permission to execute this action'}</em>;
            }
            return <em>{"Can't display data"}</em>;
        }

        return [
            <h5 key="h4-1">Inherited permissions from the parent folder</h5>,
            this.getInherited(permissions),
            <h5 key="h4-2">Permissions specified for this folder</h5>,
            this.getSpecific(permissions)
        ];
    };

    getContent = () => {
        if (this.state.dirLoading === true || this.state.initialLoading === true) {
            return <ProgressBar />;
        } else {
            return this.getView();
        }
    };

    containerClick = (e) => {
        reactGlobalClick.cancel(1);
    };

    render() {
        const bodyStyle = {
            maxHeight: this.state.containerSize
        };

        return (
            <div className="permissions-dir" onClick={this.containerClick}>
                <div className="modal fade show" role="dialog">
                    <div className="modal-dialog" 
                        ref={(input) => {
                            this.references.container = input;
                        }} //LL: 31.01.25
                    >
                        <div className="modal-content">
                            <div className="modal-header" 
                                ref={(input) => {
                                    this.references.header = input;
                                }} //LL: 31.01.25
                            >
                                <h4 className="modal-title">
                                    {this.state.displayName != null
                                        ? "Edit permissions for the folder '" + this.state.displayName + "'"
                                        : 'Edit the folder permissions'}
                                </h4>
                                <button type="button" className="close" onClick={this.handleOnCloseDialog}>
                                    &times;
                                </button>
                            </div>

                            <div className="modal-body container-fluid" style={bodyStyle}>
                                {this.getContent()}
                            </div>

                            <div className="modal-footer" 
                                ref={(input) => {
                                    this.references.footer = input;
                                }} //LL: 31.01.25
                            >
                                {this.getActionButtons()}

                                <button type="button" className="btn btn-default" onClick={this.handleOnCloseDialog}>
                                    {'Cancel'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}
